import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import DataTable from './shared/DataTable';
import 'moment-timezone';
import { observer } from "mobx-react";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
});

class Users extends Component {

  constructor(props) {
    super(props);
    this._validAuthStates = ['signedIn'];
    
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
  }

  componentDidMount() {
    if (this.props.userStore.searchTerm.trim()) {
      this.props.userStore.searchUser();
    } else {
      this.props.userStore.resetPagination();
      this.props.userStore.getUserList();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.searchTimeout);
  }

  handleSearchInputChange(event) {
    this.props.userStore.searchTerm = event.target.value;

    /* Only search once the user stops typing */
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => this.props.userStore.searchUser(), 300);
  }
  
  render() {
    const { classes } = this.props;

    return (
      <Grid container>
        <Grid item >
          <TextField
              id="searchTerm"
              name="searchTerm"
              label="E-Mail oder Benutzer-ID"
              type="search"
              className={classes.textField}
              margin="none"
              value={this.props.userStore.searchTerm}
              onChange={this.handleSearchInputChange} />
        </Grid>
        <DataTable 
          store={this.props.userStore} 
          rows={this.props.userStore.userList} 
          columns={this.props.userStore.tableColumns}
          history={this.props.history}
        />
      </Grid>
    );
  }
}

export default withStyles(styles)(observer(Users));
